import * as actions from './service.actions';
import { initialState } from './service.model';
import { createReducer, on } from '@ngrx/store';

export const reducer = createReducer(
  initialState,
  on(actions.contactSendMessageAction, state => ({
    contact: {
      ...state.contact,
      saving: true,
      saveSuccess: null,
    },
  })),
  on(actions.contactSendMessageSuccessAction, state => ({
    contact: {
      ...state.contact,
      saving: false,
      saveSuccess: true,
    },
  })),
  on(actions.contactSendMessageFailAction, state => ({
    contact: {
      ...state.contact,
      saving: false,
      saveSuccess: false,
    },
  }))
);
